import { Navigate, createFileRoute } from '@tanstack/react-router'
import { sidebarData } from '@/components/layout/data/sidebar-data'
import { usePermissions } from '@/features/rbac/hooks/use-permissions'

/**
 * Where a person lands after signing in.
 *
 * This used to redirect everyone to /users, which is fine for an
 * administrator and a slap in the face for a backroom worker: they arrived
 * on the one page their role forbids and were met with a red "no access"
 * toast before touching anything. Send each person to the first sidebar
 * entry they are actually allowed to open instead.
 */
function LandingRedirect() {
  const { can, isSuperAdmin, isLoading } = usePermissions()

  // Deciding before permissions arrive is what caused the bad redirect.
  if (isLoading) return null

  const firstAllowed = sidebarData.navGroups
    .flatMap((group) => group.items)
    .find((item) => {
      if (!('url' in item) || !item.url) return false
      if (!item.permission) return true
      if (isSuperAdmin) return true
      const keys = Array.isArray(item.permission)
        ? item.permission
        : [item.permission]
      return can(...keys)
    })

  const to = (firstAllowed && 'url' in firstAllowed && firstAllowed.url) || '/'

  // Nothing at all is visible — better a bare shell than a redirect loop.
  if (to === '/') return null

  return <Navigate to={to} replace />
}

export const Route = createFileRoute('/_authenticated/')({
  component: LandingRedirect,
})
